// Shared constants used by more than one component of the redesigned site.
// Content specific to a single section (feature list, sheet list, premium points,
// social links) lives inline in that section's own component instead.

export const IOS_URL = 'https://apps.apple.com/in/app/thriill-train-your-ear/id6744299502';
export const ANDROID_URL = 'https://play.google.com/store/apps/details?id=com.thriill.app';

export const NAV_ITEMS = [
  { label: 'Home', href: '#top', home: true },
  { label: 'Try it', href: '#teaser' },
  { label: 'Features', href: '#features' },
  { label: 'Repertoire', href: '#repertoire' },
  { label: 'Premium', href: '#premium' },
  { label: 'Download & Contact', href: '#download' },
];

export const HERO_EMBED =
  'https://www.youtube-nocookie.com/embed/Tf2FhaH9suA?autoplay=1&mute=1&loop=1&playlist=Tf2FhaH9suA&playsinline=1&rel=0&modestbranding=1&enablejsapi=1&controls=0&cc_load_policy=0&iv_load_policy=3&disablekb=1';

export const REPERTOIRE_EMBED =
  'https://www.youtube-nocookie.com/embed/unhLZzvQg_s?autoplay=1&mute=1&loop=1&playlist=unhLZzvQg_s&start=1&end=15&playsinline=1&rel=0&modestbranding=1&controls=0&cc_load_policy=0&iv_load_policy=3&disablekb=1';
